import React from 'react';
import {
    TextInput,
    DateInput,
    Create,
    SimpleForm,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Notification,
    
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import { Redirect } from 'react-router-dom';


let ssn = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const ABSCEditActions = ({props}) => (
    ssn = (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn,
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/absc?filter=%7B"ssn"%3A"' + ssn +'"%7D&order=DESC&page=1&perPage=25&sort=id'} label='ABSC List'/>
    </CardActions>
);

const editStyles = {
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '30em' },
};


const ABSCToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect={'/absc?filter=%7B"ssn"%3A"' + ssn +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
            submitOnEnter={true}
        />
    </Toolbar>
);

const GetKey=({ props }) => (
    ssn = (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn,
    (ssn)? '': <Redirect to="/donors" />
);


const AbscCreate =({ classes, ...props }) => (
    
<Create 
    title='ABSC Add' 
    {...props}  
    actions={<ABSCEditActions props={props} />} 
    >
   <SimpleForm  toolbar={<ABSCToolbar />}> 
       <TextInput source="ssn" defaultValue={ (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn} disabled validate={required()} />
       <DateInput source="collect_date" locales="en-us" label="Date of Collection" validate={required()} />
       <DateInput source="next_date" locales="en-us" label="Next Due Date"/>
       <TextInput source="tech_init" label="Tech Initial" />
       <TextInput source="qa_init" label="QA Initial" />
       <DateInput source="qa_date" locales="en-us" label="QA Date"/>
       <GetKey props ={props}/>
   </SimpleForm>
    </Create>
);

export default withStyles(editStyles)(AbscCreate);